import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export default function UnsavedDrawer({
  modifyAttributes,
  refresh,
}: {
  modifyAttributes: () => Promise<void>;
  refresh: () => void;
}) {
  const targetAttrCtx = useContext(ctxTargetAttributes);

  const { t } = useTranslation();

  if (!targetAttrCtx) return;

  return (
    <Drawer
      anchor="bottom"
      open={targetAttrCtx.drawerOpen}
      onClose={() => targetAttrCtx.setDrawerOpen(false)}
      slotProps={{
        root: { sx: { zIndex: 1300 } },
        paper: {
          sx: {
            paddingBottom: '70px',
            overflowY: 'auto',
            borderRadius: '20px',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          gap: 2,
          padding: '24px',
        }}
      >
        <Typography variant="h6">{t('targetAttributes.unsavedTitle')}</Typography>
        <Typography>{t('targetAttributes.unsavedSubtitle')}</Typography>
        <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            sx={{ padding: '6px 16px' }}
            onClick={modifyAttributes}
          >
            {t('targetAttributes.saveButton')}
          </Button>
          <Button variant="outlined" size="large" color="secondary" sx={{ padding: '5px 15px' }} onClick={refresh}>
            {t('targetAttributes.discardButton')}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
